module.exports = __webpack_public_path__ + "static/dev-mobile-414fb4b9bd8744953c26ddf0ce80f12a.jpg";